(function () {
    'use strict';

    function fixEmptyMegaMenus() {
        // 查找移动端容器
        const mobileContainers = document.querySelectorAll('.navigation__tier-2-container[id*="mobMobileNav"]');

        mobileContainers.forEach(function (container) {
            // 检查容器是否包含产品预览（表示这是一个mega menu）
            const hasProductPreview = container.querySelector('.navigation__column--main-product-preview');

            if (hasProductPreview) {
                const tier2 = container.querySelector('.navigation__tier-2');
                if (!tier2) return;

                // 检查现有的菜单项（排除产品预览）
                const existingItems = tier2.querySelectorAll('.navigation__item:not(.navigation__column--main-product-preview)');

                // 检查是否已经有新的移动端产品缩略图结构
                const hasMobileThumbnails = tier2.querySelector('.navigation__mobile-menu-with-thumbnails');

                // 如果只有产品预览，没有实际菜单项，且没有移动端缩略图结构
                if (existingItems.length === 0 && !hasMobileThumbnails) {
                    // 隐藏产品预览
                    const productPreview = tier2.querySelector('.navigation__column--main-product-preview');
                    if (productPreview) {
                        productPreview.style.display = 'none';
                    }

                    // 获取当前移动端容器的ID，找到对应的桌面端容器
                    const mobileId = container.id;
                    const desktopId = mobileId.replace('-mobMobileNav', '');
                    const desktopContainer = document.querySelector(`#${desktopId}`);
                    let realMenuItems = [];

                    if (desktopContainer) {
                        const desktopTier2 = desktopContainer.querySelector('.navigation__tier-2');

                        if (desktopTier2) {
                            // 直接查找所有菜单链接，排除产品预览列
                            const menuLinks = desktopTier2.querySelectorAll('.navigation__column:not(.navigation__column--main-product-preview) .navigation__link');

                            menuLinks.forEach(function (link) {
                                const linkText = link.textContent.trim();
                                const linkUrl = link.href;

                                if (linkText && linkText !== 'View More' && linkText !== 'View All') {
                                    realMenuItems.push({
                                        text: linkText,
                                        url: linkUrl
                                    });
                                }
                            });

                            // 尝试查找所有链接，不管层级
                            if (realMenuItems.length <= 1) {
                                const allLinks = desktopTier2.querySelectorAll('a');

                                allLinks.forEach(function (link) {
                                    const linkText = link.textContent.trim();
                                    const linkUrl = link.href;
                                    const isProductPreview = link.closest('.navigation__column--main-product-preview');
                                    const isViewMore = linkText === 'View More' || linkText === 'View All';

                                    if (linkText && !isProductPreview && !isViewMore) {
                                        // 检查是否已经存在
                                        const exists = realMenuItems.some(item => item.text === linkText);
                                        if (!exists) {
                                            realMenuItems.push({
                                                text: linkText,
                                                url: linkUrl
                                            });
                                        }
                                    }
                                });
                            }
                        }
                    }

                    // 如果只找到一个菜单项或没有找到，添加更多默认项
                    if (realMenuItems.length <= 1) {
                        // 保留已找到的项目，然后添加更多
                        const existingUrls = realMenuItems.map(item => item.url);

                        const additionalItems = [
                            { text: 'All Tricycle', url: '/collections/tricycle' },
                            { text: 'Kids Tricycle', url: '/collections/kids-tricycles' },
                            { text: 'Adult Tricycle', url: '/collections/adult-tricycles' },
                            { text: 'Electric Tricycle', url: '/collections/electric-tricycles' }
                        ];

                        // 只添加不重复的项目
                        additionalItems.forEach(item => {
                            if (!existingUrls.includes(item.url)) {
                                realMenuItems.push(item);
                            }
                        });
                    }

                    // 清空tier-2内容并重新构建
                    tier2.innerHTML = '';
                    tier2.style.cssText = `
                        display: block !important;
                        flex-direction: column !important;
                        padding: 0 !important;
                        background: transparent !important;
                        list-style: none !important;
                        margin: 0 !important;
                    `;

                    realMenuItems.forEach(function (item) {
                        // 创建菜单项
                        const menuItem = document.createElement('li');
                        menuItem.className = 'navigation__item';
                        menuItem.style.cssText = `
                            display: block !important;
                            width: 100% !important;
                            margin: 0 !important;
                            padding: 0 !important;
                        `;

                        // 创建链接
                        const link = document.createElement('a');
                        link.className = 'navigation__link';
                        link.href = item.url;
                        link.textContent = item.text;
                        link.style.cssText = `
                            display: block !important;
                            padding: 12px 20px !important;
                            font-size: inherit !important;
                            color: inherit !important;
                            text-decoration: none !important;
                            background: transparent !important;
                            border: none !important;
                            transition: all 0.2s ease !important;
                        `;

                        // 组装
                        menuItem.appendChild(link);
                        tier2.appendChild(menuItem);
                    });

                    // 确保容器可见
                    container.style.display = 'block';
                } else if (hasMobileThumbnails) {
                    // 如果已经有移动端缩略图结构，确保容器可见但不重建
                    container.style.display = 'block';
                    // 隐藏桌面端产品预览
                    const productPreview = tier2.querySelector('.navigation__column--main-product-preview');
                    if (productPreview) {
                        productPreview.style.display = 'none';
                    }
                }
            }
        });
    }

    // 监听Mega菜单点击
    function observeMegaMenuClick() {
        document.addEventListener('click', function (e) {
            const menuItem = e.target.closest('.navigation__item');
            if (menuItem) {
                const menuLink = menuItem.querySelector('.navigation__link');
                if (menuLink) {
                    // 检查是否是有产品预览的菜单项
                    const hasProductPreview = menuItem.closest('.navigation__tier-1').querySelector('.navigation__item--with-main-product-preview');
                    if (hasProductPreview) {
                        setTimeout(fixEmptyMegaMenus, 100);
                        setTimeout(fixEmptyMegaMenus, 300);
                    }
                }
            }
        });
    }

    // 监听移动端导航打开
    function observeMobileNavigation() {
        const mobileNavDrawer = document.querySelector('.mobile-navigation-drawer');

        if (mobileNavDrawer) {
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if (mobileNavDrawer.classList.contains('mobile-navigation-drawer--open')) {
                            setTimeout(fixEmptyMegaMenus, 200);
                        }
                    }
                });
            });

            observer.observe(mobileNavDrawer, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }

    // 移动端产品缩略图功能
    function initMobileThumbnails() {
        // 处理移动端产品缩略图的自动关闭导航功能
        const thumbnailLinks = document.querySelectorAll('[data-mobile-nav-close]');

        thumbnailLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                // 添加点击反馈效果
                addClickFeedback(link);

                // 延迟关闭导航，让用户看到点击效果
                setTimeout(function () {
                    closeMobileNavigation();
                }, 100);
            });

            // 添加触摸优化
            link.addEventListener('touchstart', function (e) {
                link.style.opacity = '0.7';
                link.style.transform = 'scale(0.95)';
            });

            link.addEventListener('touchend', function (e) {
                setTimeout(function () {
                    link.style.opacity = '';
                    link.style.transform = '';
                }, 150);
            });
        });
    }

    function addClickFeedback(element) {
        // 添加视觉反馈
        element.style.opacity = '0.7';
        element.style.transform = 'scale(0.95)';
        element.style.transition = 'all 0.1s ease';

        setTimeout(function () {
            element.style.opacity = '';
            element.style.transform = '';
        }, 150);
    }

    function closeMobileNavigation() {
        // 查找并关闭移动端导航菜单
        const mobileNav = document.querySelector('.mobile-navigation-drawer');
        const body = document.body;
        const mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]');

        if (mobileNav && body.classList.contains('mobile-navigation-open')) {
            // 移除打开状态的类
            body.classList.remove('mobile-navigation-open');

            // 设置导航为隐藏状态
            mobileNav.setAttribute('aria-hidden', 'true');

            // 如果有切换按钮，更新其状态
            if (mobileNavToggle) {
                mobileNavToggle.setAttribute('aria-expanded', 'false');
            }

            // 恢复页面滚动
            body.style.overflow = '';

            // 触发自定义事件，通知其他组件导航已关闭
            const closeEvent = new CustomEvent('mobileNavigationClosed', {
                bubbles: true,
                detail: { source: 'productThumbnail' }
            });
            document.dispatchEvent(closeEvent);
        }
    }

    // 初始化
    function init() {
        fixEmptyMegaMenus();
        observeMegaMenuClick();
        observeMobileNavigation();
        initMobileThumbnails();
    }

    // 监听DOM变化，重新初始化移动端缩略图功能
    function observeContentChanges() {
        const mobileNavDrawer = document.querySelector('.mobile-navigation-drawer');

        if (mobileNavDrawer) {
            const observer = new MutationObserver(function (mutations) {
                let shouldReinit = false;

                mutations.forEach(function (mutation) {
                    if (mutation.type === 'childList') {
                        // 检查是否有新的产品缩略图添加
                        mutation.addedNodes.forEach(function (node) {
                            if (node.nodeType === 1) { // Element node
                                const hasThumbnails = node.querySelector && node.querySelector('[data-mobile-nav-close]');
                                if (hasThumbnails) {
                                    shouldReinit = true;
                                }
                            }
                        });
                    }
                });

                if (shouldReinit) {
                    setTimeout(initMobileThumbnails, 100);
                }
            });

            observer.observe(mobileNavDrawer, {
                childList: true,
                subtree: true
            });
        }
    }

    // 启动
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init();
            observeContentChanges();
        });
    } else {
        init();
        observeContentChanges();
    }

    window.addEventListener('load', function () {
        setTimeout(function () {
            init();
            initMobileThumbnails(); // 确保页面完全加载后重新初始化
        }, 500);
    });

})();